export const holdingClassListPageInitValue = {
  data: {
    societyName: '',
    societyNominalValue: 0,
    holdingClassesTotal: 0,
    holdingClasses: [],
    page: 0,
    rowsPerPage: 0,
    isAdmin: false,
    isReadOnly: false,
    isLoading: false,
  },
  actions: {
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
    handleAddClass: () => {},
    handleViewClass: () => {},
    handleEditClass: () => {},
  },
};
